/** Escape a string for safe interpolation into an HTML template literal. */
export function escapeHtml(str: string): string {
  const div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}
